import { DeleteOutlined } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import { ColumnType } from 'antd/es/table'
import { ReceiptPosition } from '../receipt-form'

export default function getColumns(onRemovePosition: (i: number) => void) {
    const columns: ColumnType<ReceiptPosition>[] = [
        {
            dataIndex: ['materialType', 'name'],
            title: 'Наименование',
            width: 480,
        },
        {
            dataIndex: 'width',
            title: 'Ширина',
            width: 145,
        },
        {
            dataIndex: 'quantity',
            title: 'Кол-во',
            width: 100,
        },
        {
            dataIndex: 'unit',
            title: 'Ед. изм.',
            width: 100,
        },
        {
            dataIndex: 'actions',
            title: 'Действия',
            width: 40,
            render(v, r, i) {
                return (
                    <Flex justify={'end'}>
                        <Button
                            size={'small'}
                            icon={<DeleteOutlined />}
                            onClick={() => onRemovePosition(i)}
                            danger
                        />
                    </Flex>
                )
            },
        },
    ]

    return columns
}
